import React, { useState } from 'react';
import I18n from 'i18n-js';

import { RCSwitch, RCCheckbox, RCTextInput } from '@reverbdotcom/cadence/components';

interface IProps {
  isAutomaticOffersEnabled: boolean;
  conditionNewBrandChecked: boolean;
  conditionBStockChecked: boolean;
  conditionUsedChecked: boolean;
  autoRespondLowAmount: string;
  autoRespondHighAmount: string;
  autoPercentageAmount: string;
  autoAcceptedChecked: boolean;
  autoDeclineChecked: boolean;
  lowPercentageAmount: string;
}

export function OfferBotConfiguration(props: IProps) {
  const [isAutomaticOffersEnabled, setAutomaticOffers] = useState(props.isAutomaticOffersEnabled);
  const [isConditionBrandNewChecked, setConditionBrandNewChecked] = useState(props.conditionNewBrandChecked);
  const [isConditionBStockChecked, setConditionBStockChecked] = useState(props.conditionBStockChecked);
  const [isConditionUsedChecked, setConditionUsedChecked] = useState(props.conditionUsedChecked);
  const [autoRespondLowAmount, setAutoRespondLow] = useState(props.autoRespondLowAmount);
  const [autoRespondHighAmount, setAutoRespondHigh] = useState(props.autoRespondHighAmount);
  const [isAutoDeclineChecked, setAutoDeclineChecked] = useState(props.autoDeclineChecked);
  const [autoPercentageAbove, setAutoPercentageAbove] = useState(props.autoPercentageAmount);
  const [lowballPercentage, setLowballPercentage] = useState(props.lowPercentageAmount);
  const [isAutoAcceptedChecked, setAutoAcceptedChecked] = useState(props.autoAcceptedChecked);

  return (
    <>
      <div className="g-container">
        <div className="g-col-12">
          <RCSwitch
            checked={isAutomaticOffersEnabled}
            id="automaticOfferBot"
            label= {I18n.t('discovery.shopSettings.offerBotPolicy.automaticAcceptLabel')}
            name="automaticOfferBot"
            onChange= {() => setAutomaticOffers(!isAutomaticOffersEnabled)}
          />
        </div>        
      </div>
      { isAutomaticOffersEnabled && (
        <div className="g-container">
          <div className="g-col-12 pt-2">
            <div className="g-col-12 pt-1">
              <div className="weight-bold mb-0">
                {I18n.t('discovery.shopSettings.offerBotPolicy.conditionsTitle')}
              </div>
            </div>
            <div className="g-col-12 pt-1">
              <RCCheckbox
                id="newBrandOption"
                label={I18n.t('discovery.shopSettings.offerBotPolicy.conditionBrandNewOption')}
                name="newBrandOption"
                onChange={e => setConditionBrandNewChecked(e.target.checked)}
                checked={isConditionBrandNewChecked}
              />
            </div>
            <div className="g-col-12 pt-1">
              <RCCheckbox
                id="bStockOption"
                label={I18n.t('discovery.shopSettings.offerBotPolicy.conditionBStockOption')}
                name="bStockOption"
                onChange={e => setConditionBStockChecked(e.target.checked)}
                checked={isConditionBStockChecked}
              />
            </div>
            <div className="g-col-12 pt-1">
              <RCCheckbox
                id="usedConditionOption"
                label={I18n.t('discovery.shopSettings.offerBotPolicy.conditionUsedOption')}
                name="usedConditionOption"
                onChange={e => setConditionUsedChecked(e.target.checked)}
                checked={isConditionUsedChecked}
              />
            </div>             
          </div>
          <div className="g-col-12 pt-2">
            <div className="g-col-12 pt-1">
              <div className="weight-bold mb-0">
                {I18n.t('discovery.shopSettings.offerBotPolicy.boundariesTitle')}
              </div>
            </div>            
            <div className="g-col-10 pt-1">
              <p>{I18n.t('discovery.shopSettings.offerBotPolicy.boundariesDescription')}</p>
            </div>
            <div className="g-col-4 g-col-mobile-12">
              <RCTextInput
                id="boundariesLowAmount"
                label={I18n.t('discovery.shopSettings.offerBotPolicy.boundariesLowTitle')}
                maxLength={21}
                minLength={1}
                name="boundariesLowAmount"
                onChange={(e) => setAutoRespondLow(e.target.value)}
                prefixText="$"
                type="number"
                value={autoRespondLowAmount}
              />
            </div>
            <div className="g-col-4 g-col-mobile-12">
              <RCTextInput
                id="boundariesHighAmount"
                label={I18n.t('discovery.shopSettings.offerBotPolicy.boundariesHighTitle')}
                maxLength={21}
                minLength={1}
                name="boundariesHighAmount"
                onChange={(e) => setAutoRespondHigh(e.target.value)}
                prefixText="$"
                type="number"
                value={autoRespondHighAmount}
              />
            </div>
          </div>
          <div className="g-col-10 pt-2">
            <div className="g-col-12 pt-1">
              <div className="weight-bold mb-0">
                {I18n.t('discovery.shopSettings.offerBotPolicy.autoPercentageDescription')}
              </div>
            </div>
            <div className="g-col-10 g-col-mobile-12 pt-1">
              <p>{I18n.t('discovery.shopSettings.offerBotPolicy.autoPercentageExample')}</p>
            </div>            
            <div className="g-col-4 g-col-mobile-12">
              <RCTextInput
                id="autoPercentageAbove"
                label={I18n.t('discovery.shopSettings.offerBotPolicy.autoPercentageLabel')}
                maxLength={21}
                minLength={1}
                name="autoPercentageAbove"
                onChange={(e) => setAutoPercentageAbove(e.target.value)}
                suffixText="%"
                type="number"
                value={autoPercentageAbove}
              /> 
            </div>                
          </div>
          <div className="g-col-12 pt-2">
            <div className="g-col-12 pt-1">
              <div className="weight-bold mb-0">
                {I18n.t('discovery.shopSettings.offerBotPolicy.autoDeclineQuestion')}
              </div>
            </div>
            <div className="g-col-12 pt-1">
              <RCCheckbox
                id="autoDeclineOption"
                label={I18n.t('discovery.shopSettings.offerBotPolicy.autoDeclineCheckboxLabel')}
                sublabel={I18n.t('discovery.shopSettings.offerBotPolicy.autoDeclineCheckboxSublabel')}
                name="autoDeclineOption"
                onChange={e => setAutoDeclineChecked(e.target.checked)}
                checked={isAutoDeclineChecked}
              />
            </div>
            { isAutoDeclineChecked && (
              <div className="g-col-4 g-col-mobile-12 pt-1 plr-3">
                <RCTextInput
                  id="lowballPercentage"
                  label={I18n.t('discovery.shopSettings.offerBotPolicy.lowballPercentageTitle')}
                  helpText={I18n.t('discovery.shopSettings.offerBotPolicy.lowballPercentageHelpMessage')}
                  maxLength={21}
                  minLength={1}
                  name="lowballPercentage"
                  onChange={(e) => setLowballPercentage(e.target.value)}
                  suffixText="%"
                  type="number"
                  value={lowballPercentage}
                /> 
              </div>
            )}
          </div>
          <div className="g-col-12 pt-2">
            <div className="g-col-12 pt-1">
              <div className="weight-bold mb-0">
                {I18n.t('discovery.shopSettings.offerBotPolicy.autoAcceptQuestion')}
              </div>
            </div>
            <div className="g-col-12 pt-1">
              <RCCheckbox
                id="autoAcceptOption"
                label={I18n.t('discovery.shopSettings.offerBotPolicy.autoAcceptCheckboxLabel')}
                name="autoAcceptOption"
                onChange={e => setAutoAcceptedChecked(e.target.checked)}
                checked={isAutoAcceptedChecked}
              />
            </div>
          </div>
        </div>    
      )}
    </>            
  );
}
